import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/enterprisearmenia.am/httpdocs/frontend/src/modules/Search/index.js");
